<template>
  <div class="">
    <v-container fluid>
      <v-row class="mb-4">
        <v-col
          class="
            box-white
            text-center
            py-1
            text-subtitle-2
            text-sm-subtitle-1
            text-md-subtitle-1
            text-lg-subtitle-1
            text-xl-subtitle-1
          "
        >
          <span v-if="areaSelected">
            {{ areaSelected.name }}
          </span>
        </v-col>
      </v-row>
      <agronomic-management-form
       
      ></agronomic-management-form>
     
    </v-container>
        <!-- copyright -->
    <v-footer class=" text-caption text-center d-flex justify-center"  fixed> D.R. © Solena Ag, Inc. {{new Date().getFullYear()}} </v-footer>
  </div>
</template>

<script>
// vuex
import { mapState, mapActions, mapMutations } from "vuex";
// components
import AgronomicManagementForm from "@/components/territory/AgronomicManagementForm.vue";


export default {
  components: { AgronomicManagementForm },
  async created() {},
  mounted() {},
  computed: {
    ...mapState("areasList", ["areaSelected"]),
   
  },
  methods: {
    ...mapActions("areasList", ["getAreaById"]),
    ...mapMutations("areasList", ["SET_AREA_SELECTED"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    ...mapMutations("agronomic", ["SET_FORM"]),
    closeMap() {
      this.SET_FORM(false);
    },
  },
};
</script>

<style scoped>
.box-white {
  background: #ffffff;
}
</style>
